<mat-dialog-content>

    <div class="row">
        <div class="col-sm-12">
            <mat-card>
                <mat-card-title class="font-weight-bold caption-color"><b>Rental PL Detail (For Sales Booking)</b>
                </mat-card-title>
                <mat-divider></mat-divider>
                <mat-card-content class="pt-2">
                    <div class="row">
                        <div class="col-sm-12">

                            <table class="table">
                                
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th></th>    
                                            <th *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;" class="text-center"> {{i+1}} years</th> 
                                            <th class="text-right">Total</th> 
                                        </tr>
                                    </thead>
                               
                                <tbody>
                                    <tr>
                                        <td><b>Revenue</b></td>
                                        <td></td>
                                        <td *ngFor="let i of spraRentalPL.NoOfYears"></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>Yearly CSA Revenue</b></td>
                                        <!-- {{spraRentalPL.YearCSARevnue}}^{{item}} ^ -->
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;" class="text-right">{{(spraRentalPL.YearCSARevnue * item) | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumYearlyCSARevenue  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>Yearly Rental Revenue</b></td>
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;" class="text-right">{{(spraRentalPL.MonthlyRent * item) | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumRentalRev  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>Total Revenue</b></td>
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;" class="text-right">{{(spraRentalPL.YearCSARevnue * item + spraRentalPL.MonthlyRent * item) | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.TotRevenue  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Expenses</b></td>
                                        <td></td>
                                        <td *ngFor="let i of spraRentalPL.NoOfYears"></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>CSA Cost(landed cost)</b></td>
                                        <!-- {{spraRentalPL.CSACostLanded }}^{{item}} ^  -->
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;" class="text-right">{{(spraRentalPL.CSACostLanded * item) | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumCSAcost | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>CSA Cost for Free Copies</b></td>
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;" class="text-right">{{(spraRentalPL.CSACostFreeCopies * item) | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumCSAFreeCopies | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>Depreciation</b></td>
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;" class="text-right">{{(spraRentalPL.DepreciationVal * item) | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumDepreciation  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>Interest Cost (by total emi chart)</b></td>
                                        <td *ngFor="let item of spraRentalPL.InterestPL;  let i = index;" class="text-right">{{item  | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumInterest  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>
                                            <div class="form-inline">
                                            Insurance Expenses <input class="e-small" name="txtPercentage" [(ngModel)]="spraRentalPL.InsPerc" (ngModelChange)="SpraRentalPLCalculation.InsPercChange(spraRentalPL.InsPerc)" >%
                                        </div>
                                        </b></td>
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;" class="text-right">{{(spraRentalPL.InsuranceVal * item) | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumInsurance  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>
                                            <div class="form-inline">
                                            Bad Debt <input class="e-small" name="txtBadDebt" [(ngModel)]="spraRentalPL.BadDebtPerc" (ngModelChange)="SpraRentalPLCalculation.BadDebtPercChange(spraRentalPL.BadDebtPerc)" >%
                                        </div>
                                        </b></td>
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;" class="text-right">{{(spraRentalPL.BadDebtVal * item) | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumBadDebt  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>
                                            <div class="form-inline">
                                            Collection Agency Charges @ <input class="e-small" name="txtCollChargesPerc" [(ngModel)]="spraRentalPL.CollChargesPerc" (ngModelChange)="SpraRentalPLCalculation.CollChargesPercChange(spraRentalPL.CollChargesPerc)" >%
                                        </div>
                                        </b></td>
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;" class="text-right">{{(spraRentalPL.CollChargesVal * item) | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumCollChargesVal  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>Total Expenses</b></td>
                                        <td *ngFor="let item of spraRentalPL.TotExpenseWithInt;  let i = index;" class="text-right">{{item  | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumTotExpenses  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;"></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>Profit without interest </b>
                                        <td *ngFor="let item of spraRentalPL.ProfitWithOutInt;  let i = index;" class="text-right">{{(item) | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumProfitWithoutInt  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>Profit without interest % on Revenue </b></td>
                                        <td *ngFor="let item of spraRentalPL.ProfitWithOutIntPerc;  let i = index;" class="text-right">
                                            {{(item) | number : '1.2-2' }}%</td>
                                        <td class="text-right">{{spraRentalPL.SumProfitWithoutIntPerc  | number : '1.2-2'}}%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td *ngFor="let item of spraRentalPL.NoOfYears;  let i = index;"></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>Profit with interest </b></td>
                                        <td *ngFor="let item of spraRentalPL.ProfitWithInt;  let i = index;" class="text-right">{{item  | number : '1.2-2'}}</td>
                                        <td class="text-right">{{spraRentalPL.SumProfitWithInt  | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><b>Profit with interest % on Revenue </b></td>                                      
                                            <td *ngFor="let item of spraRentalPL.ProfitWithIntPerc;  let i = index;" class="text-right">
                                                {{item | number : '1.2-2'}}%</td>
                                            <td class="text-right">{{spraRentalPL.SumProfitWithIntPerc  | number : '1.2-2'}}%</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <br>
        <br>
        <div class="col-sm-12">
            <mat-card>
                <mat-card-title class="font-weight-bold caption-color"><b>Note : IN case of Per Copy Contract, extra CSA Revenue towards cost of machine is as follows</b>
                </mat-card-title>
                <mat-divider></mat-divider>
                <mat-card-content class="pt-2">
                    <div class="row">
                        <div class="col-sm-12">

                            <table class="table">
                                
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th><b>Particulars</b></th>    
                                            <th  class="text-right" *ngFor="let item of CounterDetail; let i = index;"> {{item.CounterDesc }}</th> 
                                            <!-- <th  class="text-right"> B/W A4</th> 
                                            <th  class="text-right">Color A4</th> 
                                            <th  class="text-right"> B/W A3</th> 
                                            <th  class="text-right">Color A3</th>  -->
                                        </tr>
                                    </thead>
                               
                                <tbody>
                                   
                                    <tr>
                                        <th></th>
                                        <th>Standard CSA Rate</th>    
                                        <td  class="text-right" *ngFor="let item of CounterDetail; let i = index;"> {{item.StdCSARate | number : '1.2-2'}}</td> 
                                        <!-- <th class="text-right"> {{spraRentalPL.CSACostRateBW | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{spraRentalPL.CSACostRateColor | number : '1.2-2'}}</th> 
                                        <th class="text-right"> {{spraRentalPL.CSACostRateBWA3 | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{spraRentalPL.CSACostRateColorA3 | number : '1.2-2'}}</th>  -->
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>Agreed CSA Rate</th>    
                                        <td  class="text-right" *ngFor="let item of CounterDetail; let i = index;"> {{item.AgreedCSARate | number : '1.2-2'}}</td> 
                                        <!-- <th class="text-right"> {{spraRentalPL.AgreedCSARateBW | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{spraRentalPL.AgreedCSARateColor | number : '1.2-2'}}</th> 
                                        <th class="text-right"> {{spraRentalPL.AgreedCSARateBWA3 | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{spraRentalPL.AgreedCSARateColorA3 | number : '1.2-2'}}</th>  -->
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>Addl CSA rate recovered towards cost of M/c</th>    
                                        <td  class="text-right" *ngFor="let item of CounterDetail; let i = index;"> {{(item.AgreedCSARate - item.StdCSARate) | number : '1.2-2'}}</td> 
                                        <!-- <th class="text-right"> {{spraRentalPL.AgreedCSARateBW- spraRentalPL.CSACostRateBW | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{spraRentalPL.AgreedCSARateColor - spraRentalPL.CSACostRateColor | number : '1.2-2'}}</th> 
                                        <th class="text-right"> {{spraRentalPL.AgreedCSARateBWA3- spraRentalPL.CSACostRateBWA3 | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{spraRentalPL.AgreedCSARateColorA3- spraRentalPL.CSACostRateColorA3 | number : '1.2-2'}}</th>  -->
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>Minimum Monthly Billing</th>    
                                        <td  class="text-right" *ngFor="let item of CounterDetail; let i = index;"> {{item.EMCL | number : '1.2-2'}}</td> 
                                        <!-- <th class="text-right"> {{spraRentalPL.EstMinimumCopyPerMonthBW | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{spraRentalPL.EstMinimumCopyPerMonthColor | number : '1.2-2'}}</th> 
                                        <th class="text-right"> {{spraRentalPL.EstMinimumCopyPerMonthBWA3 | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{spraRentalPL.EstMinimumCopyPerMonthColorA3 | number : '1.2-2'}}</th>  -->
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>Addl Monthly CSA Revenue towards Cost of M/c</th>                                            
                                        <td  class="text-right" *ngFor="let item of CounterDetail; let i = index;"> {{((item.AgreedCSARate - item.StdCSARate)*item.EMCL) | number : '1.2-2'}}</td> 
                                        <!-- <th class="text-right"> {{(spraRentalPL.AgreedCSARateBW- spraRentalPL.CSACostRateBW) * spraRentalPL.EstMinimumCopyPerMonthBW | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{(spraRentalPL.AgreedCSARateColor - spraRentalPL.CSACostRateColor)* spraRentalPL.EstMinimumCopyPerMonthColor | number : '1.2-2'}}</th> 
                                        <th class="text-right"> {{(spraRentalPL.AgreedCSARateBWA3- spraRentalPL.CSACostRateBWA3) * spraRentalPL.EstMinimumCopyPerMonthBWA3 | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{(spraRentalPL.AgreedCSARateColorA3- spraRentalPL.CSACostRateColorA3) * spraRentalPL.EstMinimumCopyPerMonthColorA3 | number : '1.2-2'}}</th>  -->
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>Annual CSA Revenue towards cost of M/c</th>    
                                        <td  class="text-right" *ngFor="let item of CounterDetail; let i = index;"> {{((item.AgreedCSARate - item.StdCSARate)*item.EMCL*12) | number : '1.2-2'}}</td> 
                                        <!-- <th class="text-right"> {{(spraRentalPL.AgreedCSARateBW- spraRentalPL.CSACostRateBW) * spraRentalPL.EstMinimumCopyPerMonthBW * 12 | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{(spraRentalPL.AgreedCSARateColor - spraRentalPL.CSACostRateColor)* spraRentalPL.EstMinimumCopyPerMonthColor * 12 | number : '1.2-2'}}</th> 
                                        <th class="text-right"> {{(spraRentalPL.AgreedCSARateBWA3- spraRentalPL.CSACostRateBWA3) * spraRentalPL.EstMinimumCopyPerMonthBWA3 * 12 | number : '1.2-2'}}</th> 
                                        <th class="text-right">{{(spraRentalPL.AgreedCSARateColorA3- spraRentalPL.CSACostRateColorA3) * spraRentalPL.EstMinimumCopyPerMonthColorA3 *12 | number : '1.2-2'}}</th>  -->
                                    </tr>
                                
                                    
                                    
                                </tbody>
                            </table>

                        </div>

                    </div>
                </mat-card-content>
            </mat-card>
        </div>

    </div>


</mat-dialog-content>